(function () {
  var CURRENCY = '৳';
  var dirty = false;
  function money(c){return CURRENCY+(c/100).toLocaleString('en-IN',{maximumFractionDigits:2});}
  function getCart(){return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();});}
  var lastCart=null;
  function toast(msg){
    var t=document.getElementById('sj-toast');
    if(!t){t=document.createElement('div');t.id='sj-toast';
      t.style.cssText='position:fixed;left:50%;bottom:24px;transform:translate(-50%,120px);background:#1d1a2e;color:#fff;padding:10px 18px;border-radius:999px;font-size:14px;z-index:1000;transition:transform .3s;white-space:nowrap';
      document.body.appendChild(t);}
    t.textContent=msg;t.style.transform='translate(-50%,0)';
    clearTimeout(t._h);t._h=setTimeout(function(){t.style.transform='translate(-50%,120px)';},1800);
  }
  function markInCart(cart){
    lastCart=cart;var ids={};
    cart.items.forEach(function(i){ids[String(i.variant_id)]=true;});
    document.querySelectorAll('[data-sj-add]').forEach(function(b){
      var inCart=!!ids[b.dataset.sjAdd];b.classList.toggle('is-in',inCart);
      var txt=inCart?'View cart':'Add to cart';if(b.textContent!==txt)b.textContent=txt;});
    var f=document.getElementById('sj-float');
    if(f){f.querySelector('[data-count]').textContent=cart.item_count+' ITEMS';
      f.querySelector('[data-total]').textContent=money(cart.total_price);}
  }
    var startCount=null;
  function showDrawer(){var d=document.querySelector('cart-drawer');
    if(d&&typeof d.open==='function')d.open();else window.location.href='/cart';}
  function reloadAndOpen(){try{sessionStorage.setItem('sj-open-cart','1');}catch(e){}window.location.reload();}
  function openCart(){
    if(!dirty){showDrawer();return;}
    var items=document.getElementById('CartDrawer-CartItems');
    var totals=document.querySelector('#CartDrawer .totals');
        var cd=document.querySelector('cart-drawer');
    if(!items||!totals||!cd||cd.classList.contains('is-empty')||document.querySelector('cart-drawer-items.is-empty')){reloadAndOpen();return;}
    fetch(window.location.pathname+'?sections=cart-drawer&t='+Date.now(),{cache:'no-store'}).then(function(r){return r.json();}).then(function(s){
      var ni=doc.getElementById('CartDrawer-CartItems');var nt=doc.querySelector('#CartDrawer .totals');
      if(!ni||!nt){reloadAndOpen();return;}
      items.innerHTML=ni.innerHTML;totals.innerHTML=nt.innerHTML;
      dirty=false;showDrawer();
    }).catch(reloadAndOpen);
  }
  try{
    if(sessionStorage.getItem('sj-open-cart')){
      sessionStorage.removeItem('sj-open-cart');
      window.addEventListener('load',function(){setTimeout(openCart,400);});
    }
  }catch(e){}
  function refreshBubble(sections){
    if(!sections||!sections['cart-icon-bubble'])return;
    var doc=new DOMParser().parseFromString(sections['cart-icon-bubble'],'text/html');
    var el=doc.querySelector('.shopify-section');var bubble=document.getElementById('cart-icon-bubble');
    if(el&&bubble)bubble.innerHTML=el.innerHTML;
  }
  document.addEventListener('click',function(e){
    if(e.target.closest('#sj-float')){openCart();return;}
    var b=e.target.closest('[data-sj-add]');if(!b)return;e.preventDefault();
    if(b.classList.contains('is-in')){openCart();return;}
    var body={items:[{id:Number(b.dataset.sjAdd),quantity:1}],
      sections:['cart-icon-bubble'],sections_url:window.location.pathname};
    b.disabled=true;b.textContent='Adding…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json();})
      .then(function(data){
        if(data.status)throw new Error(data.description||data.message||'Could not add to cart');
        dirty=true;refreshBubble(data.sections);
        return getCart();})
      .then(function(cart){markInCart(cart);toast('Added to cart');})
      .catch(function(err){b.textContent='Add to cart';toast(err.message);})
      .finally(function(){b.disabled=false;});
  });
    document.addEventListener('submit',function(e){
    var form=e.target;
    if(!form||!form.closest||!form.closest('product-form'))return;
    if((form.getAttribute('action')||'').indexOf('/cart/add')===-1)return;
    e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
    var btn=form.querySelector('[type="submit"]');
    if(btn&&btn.classList.contains('is-in')){openCart();return;}
    var label=btn?(btn.querySelector('span')||btn):null;
    var fd=new FormData(form);fd.append('sections','cart-icon-bubble');fd.append('sections_url',window.location.pathname);
    if(btn)btn.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:fd})
      .then(function(r){return r.json();})
      .then(function(data){
        if(data.status)throw new Error(data.description||data.message||'Could not add to cart');
        dirty=true;refreshBubble(data.sections);return getCart();})
      .then(function(cart){markInCart(cart);toast('Added to cart');
        if(btn){btn.classList.add('is-in');if(label)label.textContent='View cart';}})
      .catch(function(err){toast(err.message);})
      .finally(function(){if(btn)btn.disabled=false;});
  },true);
  document.addEventListener('change',function(e){
    if(e.target.closest&&e.target.closest('variant-selects, variant-radios')){
      document.querySelectorAll('product-form [type="submit"].is-in').forEach(function(b){b.classList.remove('is-in');});}
  });
  if(typeof window.subscribe==='function'&&window.PUB_SUB_EVENTS){
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate,function(){getCart().then(markInCart);});}
  var grid=document.getElementById('ProductGridContainer');
  if(grid&&'MutationObserver' in window){
    new MutationObserver(function(){if(lastCart)markInCart(lastCart);}).observe(grid,{childList:true,subtree:true});}  getCart().then(function(c){if(startCount===null)startCount=c.item_count;markInCart(c);});
})();